import React from 'react';
import styled from 'styled-components';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isAfter } from 'date-fns';

import Modal from '../../shared/Modal';
import CreateAccount from '../../shared/CreateAccount/CreateAccount';
import Rating from '../../containers/campaigns/components/UserFeedback/Rating';

import {
  updateTileData,
  addCompletionAndPointsToProgressBar,
  setTilesData,
  setTilesState,
} from '../redux/actions';
import { getSanitizedState } from '../redux/selectors';
import { Fetcher } from '../helpers';
import { api } from '../../lib/api';
import FullSizeTile from '../../shared/FullSizeTile';
import { FullSizeTileNavigationWrapper } from '../../shared/FullSizeTile/FullSizeTileNavigationWrapper';

const Container = styled.div`
  pointer-events: ${props => (props.loading || props.disable ? 'none' : '')};
`;

const pingView = id => {
  Fetcher.xmlHttpRequest({
    method: 'POST',
    path: `/api/v1/tiles/${id}/mark_as_viewed`,
    success: () => null,
  });
};

const resetPriorSelections = () => {
  const tileQuizSection = document.getElementsByClassName(
    'multiple-choice-answer',
  );

  const freeResponse = document.getElementById('free_form_response');

  if (tileQuizSection.length) {
    for (let i = 0; i < tileQuizSection.length; i++) {
      tileQuizSection[i].className = 'multiple-choice-answer';
      tileQuizSection[i].style.pointerEvents = '';

      if (tileQuizSection[i].nextElementSibling) {
        tileQuizSection[i].nextElementSibling.className = 'answer_target';
      }
    }
  }
  if (freeResponse) {
    freeResponse.value = '';
  }
};

class TileStateManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tile: {},
      currentTileIndex: null,
      loading: true,
      disable: false,
    };
    this.populateNewTileContentByIndex = this.populateNewTileContentByIndex.bind(
      this,
    );
    this.submitAnswer = this.submitAnswer.bind(this);
    this.trackLinkClick = this.trackLinkClick.bind(this);
    this.firstIncompleteTile = this.firstIncompleteTile.bind(this);
    this.tileToShow = this.tileToShow.bind(this);
    this.timer = this.setTimer.bind(this);

    this.arrowRightRef = React.createRef();
    this.arrowLeftRef = React.createRef();
  }

  static revertSelection() {
    const element = document.querySelector('div.multiple_choice_group');
    const hiddenElement = document.querySelector('[id*="form_hidden"]');

    if (element) {
      const options = element.children;

      for (let i = 0; i < options.length; i++) {
        options[i].style.display = 'block';
      }
    }

    if (hiddenElement) hiddenElement.style.display = 'none';
  }

  componentDidMount() {
    const { tileOrigin, originId } = this.props;

    this.props.loadTiles({
      loadAll: true,
      perPage: 16,
      paginateState: {
        completeTilesPage: 1,
        incompleteTilesPage: 1,
      },
      campaignUuid: this.props.tiles[tileOrigin][originId].campaignUuid,
      success: resp => {
        this.props.setTilesData(resp.tiles);
      },
    });

    this.setCurrentTileIndex(originId, tileOrigin);
    this.renderTileFullTileData(originId);
  }

  fetchFullSizeTileData(id, origin, pingTileView) {
    const shouldTranslate = origin !== 'explore';
    Fetcher.xmlHttpRequest({
      method: 'GET',
      path: `/api/v1/tiles/${id}?translate=${shouldTranslate}&ping_tile_view=${pingTileView}&include_completion=${origin ===
        'complete'}`,
      success: resp => {
        this.props.updateTileData({ id, origin, resp });
        this.setState({ tile: resp });
        this.setState({ loading: false });
      },
    });
  }

  renderTileFullTileData(id) {
    const { tiles, tileOrigin } = this.props;
    const pingTileView =
      tileOrigin === 'complete' || tileOrigin === 'incomplete'
        ? 'true'
        : 'false';
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
    if (tiles[tileOrigin][id].fullyLoaded) {
      if (tileOrigin === 'incomplete') {
        resetPriorSelections();
      }
      if (pingTileView === 'true') {
        pingView(id);
      }
      this.setState({ loading: false });
      this.setState({ tile: tiles[tileOrigin][id] });
    } else {
      this.fetchFullSizeTileData(id, tileOrigin, pingTileView);
    }
  }

  calculateRolloverIndex(differenceIndex) {
    const { tiles, tileOrigin } = this.props;
    if (
      differenceIndex >= tiles[tileOrigin].count &&
      tiles.paginateState.allTilesDisplayed
    ) {
      return 0;
    } else if (differenceIndex < 0) {
      return tiles[tileOrigin].count - 1;
    }
    return differenceIndex;
  }

  populateNewTileContentByIndex(
    indexDifference,
    nextAfterCompletion,
    nextButtonClick = false,
  ) {
    if (!this.state.loading || nextAfterCompletion) {
      window.scrollTo(0, 0);
      const { tiles, tileOrigin, originId } = this.props;
      const newIndex = this.calculateRolloverIndex(
        this.state.currentTileIndex + indexDifference,
      );

      this.setState({ loading: true });
      if (newIndex >= tiles[tileOrigin].order.length) {
        const paginateState =
          tileOrigin === 'incomplete' && !nextButtonClick
            ? { incompleteTilesPage: 1 }
            : {};

        this.props.loadTiles({
          perPage: 16,
          paginateState,
          campaignUuid: tiles[tileOrigin][originId].campaignUuid,
          success: resp => {
            this.props.addTiles(resp.tiles);
            const tileId = this.props.tiles[tileOrigin].order[newIndex]
              ? this.props.tiles[tileOrigin].order[newIndex]
              : this.props.tiles[tileOrigin].order[0];
            this.renderTileFullTileData(tileId);
            this.setState({ currentTileIndex: newIndex });
          },
          // eslint-disable-next-line no-console
          error: err => console.error(err),
        });
      } else {
        this.constructor.revertSelection();
        this.renderTileFullTileData(tiles[tileOrigin].order[newIndex]);
        this.setState({ currentTileIndex: newIndex });
      }
    }
    clearTimeout(this.timer);
  }

  setCurrentTileIndex(id, tileOrigin) {
    const currentTileIndex = this.props.tiles[tileOrigin].order.indexOf(id);
    this.setState({ currentTileIndex });
  }

  setTimer() {
    this.timer = setTimeout(() => {
      this.setState({ disable: false });
      setTimeout(() => {
        this.populateNewTileContentByIndex(1, true);
      }, 500);
    }, 500);
  }

  submitAnswer(id, answerIndex, freeFormResponse, correctAnswer) {
    const origin = this.props.tileOrigin;
    const tile = this.props.tiles[origin][id];

    if (tile.status === 'plan') {
      return;
    }

    if (correctAnswer === false) {
      api({
        method: 'post',
        url: '/api/wrong_tile_completions',
        data: {
          wrong_tile_completion: {
            tile_id: id,
            answer_index: answerIndex,
          },
        },
      });
    } else {
      setTimeout(() => {
        if (origin === 'explore') {
          this.setTimer();
        } else {
          Fetcher.xmlHttpRequest({
            method: 'POST',
            path: `/api/tile_completions`,
            params: {
              tile_id: id,
              answer_index: answerIndex,
              free_form_response: freeFormResponse,
            },
            success: () => {
              const ratingsCreationDate = new Date(
                process.env.RATINGS_CREATION_DATE,
              );
              const campaignCreationDate = new Date(tile.campaignCreatedAt);
              const {
                progressBarData,
                demo,
                userData,
                organization,
              } = this.props;
              this.props.updateTileData({
                origin,
                id,
                resp: { answerIndex, freeFormResponse, complete: true },
              });
              this.props.addCompletionAndPointsToProgressBar({
                points: tile.points,
                completion: 1,
              });
              if (
                progressBarData &&
                progressBarData.completedTiles + 1 ===
                  progressBarData.incompletedTiles
              ) {
                let uri =
                  demo.isPublic && userData.isGuestUser
                    ? `/ard/${demo.publicSlug}/activity`
                    : `/activity`;

                if (!demo.moments && tile.campaignUuid) {
                  uri = `${uri}?campaign_id=${tile.campaignUuid}`;
                }

                this.props.setTilesState({});

                if (
                  demo.newAirbo &&
                  isAfter(campaignCreationDate, ratingsCreationDate) &&
                  !userData.campaignFeedbacksIds.includes(tile.campaignUuid) &&
                  !userData.isGuestUser
                ) {
                  this.props.navigateTo(uri);

                  Modal({
                    component: <Rating campaignUuid={tile.campaignUuid} />,
                    width: '500px',
                    padding: '25px',
                  });
                } else {
                  this.props.navigateTo(uri, {
                    flash: {
                      success: true,
                      title: 'Congratulations!',
                      child: `You've finished all new ${organization.tilesWording}!`,
                      event: 'allTilesCompleted',
                      confirmBtnCssClass: 'primary-blue-button',
                    },
                  });
                }

                if (this.props.shouldConvertGuestAsUser) {
                  Modal({
                    component: <CreateAccount origin="tileCompletion" />,
                    width: '405px',
                    padding: '24px',
                  });
                }
              } else {
                this.populateNewTileContentByIndex(1, true);
              }
              // Patch sign up modal to communicate with React for every 2nd tile answered
              if (document.getElementById('guest-conversion-modal')) {
                window.Airbo.PubSub.publish('tileAnswered');
              }
            },
            err: () => {
              this.populateNewTileContentByIndex(1);
            },
          });
        }
      }, 500);
    }
  }

  trackLinkClick(target, tileId) {
    const clickedLink = target.getAttribute('href');
    if (this.props.tileOrigin !== 'explore') {
      Fetcher.xmlHttpRequest({
        method: 'POST',
        path: `/api/tiles/${tileId}/tile_link_trackings`,
        params: { clicked_link: clickedLink },
        success: () => {},
      });
    }
  }

  tileToShow() {
    const { tiles, tileOrigin } = this.props;
    const currentTileId = tiles[tileOrigin].order[this.state.currentTileIndex];

    return tiles[tileOrigin][currentTileId];
  }

  firstIncompleteTile() {
    const { tiles } = this.props;
    const incompleteTiles = tiles.incomplete;
    const firstTileId = incompleteTiles.order[0];

    this.setState({ currentTileIndex: 0 });

    return incompleteTiles[firstTileId];
  }

  render() {
    if (!this.state.tile.id) return null;

    return (
      <Container $loading={this.state.loading} disable={this.state.disable}>
        <FullSizeTileNavigationWrapper
          arrowLeftRef={this.arrowLeftRef}
          arrowRightRef={this.arrowRightRef}
        >
          <FullSizeTile
            tile={this.state.tile}
            organization={this.props.organization}
            demo={this.props.demo}
            loading={this.state.loading}
            nextTile={() => this.populateNewTileContentByIndex(1, null, true)}
            prevTile={() => this.populateNewTileContentByIndex(-1)}
            closeTile={this.props.closeTile}
            tileOrigin={this.props.tileOrigin}
            userData={this.props.userData}
            tileActions={this.props.tileActions}
            submitAnswer={this.submitAnswer}
            trackLinkClick={this.trackLinkClick}
            shouldConvertGuestAsUser={this.props.shouldConvertGuestAsUser}
            arrowRightRef={this.arrowRightRef}
            arrowLeftRef={this.arrowLeftRef}
          />
        </FullSizeTileNavigationWrapper>
      </Container>
    );
  }
}

TileStateManager.propTypes = {
  tileOrigin: PropTypes.string,
  originId: PropTypes.string,
  updateTileData: PropTypes.func,
  loadTiles: PropTypes.func,
  addTiles: PropTypes.func,
  addCompletionAndPointsToProgressBar: PropTypes.func,
  tiles: PropTypes.shape({
    explore: PropTypes.object,
    edit: PropTypes.object,
    complete: PropTypes.object,
    incomplete: PropTypes.object,
    origin: PropTypes.object,
    paginateState: PropTypes.object,
  }),
  closeTile: PropTypes.func,
  navigateTo: PropTypes.func,
  userData: PropTypes.object,
  demo: PropTypes.object,
  progressBarData: PropTypes.object,
  tileActions: PropTypes.object,
  organization: PropTypes.object,
  setTilesData: PropTypes.func,
  setTilesState: PropTypes.func,
  shouldConvertGuestAsUser: PropTypes.bool,
};

export default connect(getSanitizedState, {
  updateTileData,
  addCompletionAndPointsToProgressBar,
  setTilesData,
  setTilesState,
})(TileStateManager);
